import React, { memo, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import { loadStepStagedLoanChangesAction } from 'store/aiProcessRuns';

import StagedChangesList from './StagedChangesList';
import { buildStagedChangeCards } from './StepPendingCommitChanges.utils';

const StepPendingCommitChanges = () => {
  const dispatch = useDispatch();
  const { applicationId } = useParams();

  const [rawChanges, setRawChanges] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // commit_loan_changes takes no arguments — the changes it will persist are the
  // loan's currently-staged drafts, which live outside the tool call. Fetch them so
  // the reviewer sees exactly what will be committed (and an explicit empty state
  // when nothing is staged), rather than an argument-less "confirm" with nothing to go on.
  useEffectSafeStrictMode(() => {
    if (!applicationId) {
      setIsLoading(false);

      return;
    }

    setIsLoading(true);
    dispatch(loadStepStagedLoanChangesAction({ applicationId }))
      .then(changes => setRawChanges(changes ?? []))
      .catch(() => setRawChanges([]))
      .finally(() => setIsLoading(false));
  }, [applicationId, dispatch]);

  const changes = useMemo(() => buildStagedChangeCards(rawChanges), [rawChanges]);

  return <StagedChangesList changes={changes} isLoading={isLoading} />;
};

export default memo(StepPendingCommitChanges);
